import { getEntityType } from '@datorama/akita';
import { AbstractGitEntityStore } from '../git/state/abstract-git-entity-store.service';
import { AbstractGitFactoryService } from '../git/state/abstract-git-factory.service';
import { GitParentFolders } from '../git/state/abstract-git.service';
import { AbstractFeatureEntityState } from '../models/abstract-feature-entity-state.model';

export abstract class AbstractFeatureEntityStore<
  State extends AbstractFeatureEntityState,
  StoreModel extends getEntityType<State> = getEntityType<State>,
> extends AbstractGitEntityStore<State, StoreModel> {
  constructor(
    protected readonly cfg: {
      name: string;
      initialState: State;
      gitFactory: AbstractGitFactoryService;
      parentFolders?: GitParentFolders;
    },
  ) {
    super(cfg);
  }

  incrementLoading(): void {
    const loading = this.getValue().ui.loading || 0;
    this.updateUI({ loading: loading + 1 });
  }

  decrementLoading(): void {
    const loading = (this.getValue().ui.loading || 0) - 1;
    this.updateUI({ loading: loading > 0 ? loading : 0 });
  }

  protected updateUI(ui: Partial<State['ui']>) {
    this.update((st) => ({
      ...st,
      ui: {
        ...st.ui,
        ...ui,
      },
    }));
  }
}
